module.exports = {
	"leaflet": {
		"elementId": "ddjnrw-mst-map",
		"tileLayer": "https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png",
		"minZoom": 7,
		"maxZoom": 16
	},
	"legend": {
		"ticks": [
			25,
			50,
			75,
			100,
			125,
			150
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/config.json
// module id = 34
// module chunks = 0